<template lang="pug">
  header-section(:title="notFoundTitle", :info="notFoundInfo", simple, type="error")
    back-to-search
</template>
<script>
import BackToSearch from '@/components/record-details/BackToSearch'
import HeaderSection from '@/components/layout-components/HeaderSection'

export default {
  components: {
    BackToSearch,
    HeaderSection,
  },
  data () {
    return {
      notFoundTitle: 'LEI not found',
    }
  },
  computed: {
    notFoundInfo () {
      return `No LEI Record with LEI: ${this.$route.params.id}`
    },
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/record-details/RecordNotFound.vue